import { FormikErrors } from 'formik'
import { ImportUtilityModel } from '../typings'
import {
  isValidEmail,
  isValidMuiDate,
  isValidPhone,
} from '@sales-center/common'
import { useValidateUniqueImportName } from './useValidateUniqueImportName'
import { ImportEntityType } from '../../typings'
import { useSelector } from 'react-redux'
import { selectAllUsers } from '@user/store/users'

export function useData() {
  const allUsers = useSelector(selectAllUsers)
  const initialValues: ImportUtilityModel = {
    name: '',
    description: '',
    entityType: ImportEntityType.Lead,

    firstName: '',
    lastName: '',
    companyName: '',
    phoneNumber: '',
    phoneExt: '',
    emailAddress: '',
    salesTeamId: '',
    salesFunnelId: '',

    salesTeamName: '',
    salesFunnelName: '',

    assigneeId: '',
    leadStatus: '',
    nextActionDate: null,

    opportunityStageName: '',
    opportunityStageId: '',
    leadFunnelStageName: '',
    leadFunnelStageId: '',

    initialPrice: '',
    recurringPrice: '',

    quantity: '',

    expectedClosingDate: null,
    service: null,

    note: '',
  }

  const validateName = useValidateUniqueImportName()

  const validate = async (model: ImportUtilityModel) => {
    const errors: FormikErrors<ImportUtilityModel> = {}

    if (model.name.trim().length < 5)
      errors.name =
        'Create a unique name. Name must be between 5 and 50 characters.'

    if (model.name.trim().length >= 5) {
      const nameValidationResults = await validateName(model.name)
      if (!nameValidationResults.valid) {
        errors.name = nameValidationResults.message
      }
    }

    if (model.emailAddress && !isValidEmail(model.emailAddress))
      errors.emailAddress = 'Must be a valid email'

    if (model.phoneNumber && !isValidPhone(model.phoneNumber))
      errors.phoneNumber = 'Must be valid phone number'

    if (
      model.expectedClosingDate != null &&
      !isValidMuiDate(model.expectedClosingDate)
    )
      errors.expectedClosingDate = 'Invalid Date'

    if (model.nextActionDate != null && !isValidMuiDate(model.nextActionDate))
      errors.nextActionDate = 'Invalid Date'

    if (
      model.quantity != null &&
      model.quantity !== '' &&
      !isNaN(Number(model?.quantity))
    ) {
      if (Number(model.quantity) <= 0)
        errors.quantity = 'Quantity must be greater than 0'
    }

    if (model.assigneeId) {
      const assignee = allUsers.find((user) => user.id === model.assigneeId)
      if (assignee && !assignee.isActive) {
        errors.assigneeId = 'Owner cannot be an inactive user'
      }
    }
    return errors
  }
  return {
    validate,
    initialValues,
  }
}
